<template>
<div class="recharge" name="recharge">
    <div id="topnav">
        <div class="van-nav-bar__content">
            <div class="van-nav-bar__left"><i class="van-icon van-icon-arrow-left van-nav-bar__arrow" @click="goBack"></i></div>
            <div class="van-ellipsis van-nav-bar__title">选择套餐</div><div class="van-nav-bar__right"></div>
        </div>
    </div>

    <!-- 进度条 -->
    <div class="time-remaining">
        <p class="clear"><span class="left"></span><span class="right"></span></p>
        <div class="percent-container">
            <div class="percent-bg">
                <b></b>
                <b class="center"></b>
                <span id="percentBox"></span>
                <b></b>
            </div>
            <div class="percent-view">
                <b></b>
                <span :style="'width:'+boxWidth+'px'"></span>
                <i></i>
                <b></b>
            </div>
        </div>
        <p class="clear"><span class="left">选择套餐</span>确认支付<span class="right">充值完成</span></p>
    </div>

    <!-- 订单详情 -->
    <div class="order-content">
        <div class="parking_container">
            <h2>
                <span>选择充值车位<small>(单次最多选取50个车位)</small></span>
                <div class="extra">
                    <b :class="['cus_check_box check1',{active:allChecked}]" @click="allCheckBtn()"></b><span>全选</span>
                </div>
            </h2>
            <div class="list-box">
                <ul >
                    <li v-for="(item,index) in parkingList" :key="index">
                        <span>车位{{index+1}} 充值后有效期({{item.start.slice(0,10)}}至{{ item.stop.slice(0,10)}})</span>
                        <b :class="['cus_check_box check2',{active:item.checked}]" @click="checkParking(item, index)"></b>
                    </li>
                </ul>
            </div>
        </div>
        
        <!-- 月数 -->
        <div class="tab-btn">
            <div class="box">
                <span class="text">选择 续费月数</span>
                <div class="input-container">
                    <Stepper v-model="month" :max="12" :min="1"/>
                </div>
            </div>
            
        </div>
        <!-- 总费用 -->
        <div class="tab-btn type2">
            <div class="box">
                <span class="text">支付共计</span>
            </div>
            <b>{{totalFee}}元</b>
        </div>
    </div>

    <!-- 支付方式 -->
    <div class="popupdialog">
        <p>支付方式</p>
        <div :class="'bind_card '+bsType">
            <div v-for="(item,index) in payList" :key="index" :class="'pay-type-list '+item" @click.stop="changePayType(index)">
                <div class="box">
                    <i class="icon"></i>
                    <p v-if="payItems.hasOwnProperty(item)">{{ payItems[item] }}</p>
                        
                    <p v-if="item.indexOf('QR') != -1 && bsType=='wx'">微信支付</p>
                    <p v-if="item.indexOf('QR') != -1 && bsType=='al'">支付宝</p>
                    
                    <b :class="{active:payActiveIndex == index}"></b>
                </div>
            </div>
        </div>
    </div>

    <div class="pay_btn" @click="confirm_pay">确认缴费</div>

    <div class="tips warning">
        <h5>注意事项：</h5>
        <p>线上缴费仅支持连续月份续费，有断月（或报停月份）情况请至物业中心现场办理，请核实续费后有效期再确认缴费。</p>
    </div>
    
</div>

</template>
<script>
import topNav from "../topnav/topnav"
import { Stepper } from 'vant';
import commonService from '@/assets/commonService'
import {DETAIL as API} from "@/assets/api"
export default {
    name: 'paydetail',
    components:{
        topNav,
        Stepper,
        
    },
    data() {
        return {
            title:"选择套餐",
            boxWidth:0,
            boxMaxWidth:0,
            activeTime:0,
            monthList:["1","2","3","4","5","6"],
            month:1,
            payList:[],//支付方式
            payActiveIndex:0,//当前选中支付方式的下标
            bsType:"",//浏览器类型
            showTC:false,//是否显示弹窗
            datas:null,//
            carNum:"",//车牌号
            parkingno:"",//车场编号
            commid:"",//社区id
            //parkingno:"",//
            parkingList:[],// 车位列表
            allChecked:true,//全选标识
            checkedList:[],//选中的车位列表
            checkedStr:"",//
            totalFee:"--",//金额
            reqObj:null,//
            tradeno:"",
            projectDo:[],//支付方式处理前
            disabledClick:false,//防止暴力点击
            clickTimer:null,

            payItems: {
                'WX': '微信支付',
                'AL': '支付宝',
                'CCB': '建设银行',
                'BOC': '中国银行',
                'ICBC': '工商银行',
                'UNION': '银联支付',
                'CMBC': '招商银行',
                'HUZB': '湖州银行',
                'SCRCB': '四川农商银行',
                'BOCWISDOM': '中行智慧付',
                'JNRCB': '济南农商银行',
                'LUZB': '泸州银行',
                'ABC': '中国农业银行',
            },
            paywayList: [
                {payway: 'CCB', label: '建行支付'},
                {payway: 'CCBQR', label: '建行聚合支付'},
                {payway: 'ICBCQR', label: '工商银行支付'},
                {payway: 'UNIONQR', label: '银联聚合支付'},
                {payway: 'HUZBQR', label: '湖州银行支付'},
                {payway: 'SCRCBQR', label: '四川农商行支付'},
                {payway: 'BOCQR', label: '中国银行移动支付', isDiff: true, wxpayChannel: 'BOCWXPay', alpayChannel: 'BOCALPay'},
                {payway: 'BOCWISDOMQR', label: '中行智慧付'},
                {payway: 'CMBC', label: '招商银行支付'},
                {payway: 'CMBCQR', label: '招商银行聚合支付'},
                {payway: 'JNRCBQR', label: '济南农商银行聚合支付'},
                {payway: 'LUZBQR', label: '泸州银行聚合支付'},
                {payway: 'ABCQR', label: '中国农业银行'},
            ],
            // 暂时隐藏支付方式
            hidePayList: ['BOC', 'ICBC', 'UNION', 'CCB', 'CMBC', 'HUZB', 'SCRCB', 'BOCWISDOM', 'JNRCB', 'LUZB', 'ABC'],
        }
    },
    created(){
        this.bsType = this.$store.state.browserType;
        this.carNum = sessionStorage.getItem("carNum");
        this.parkingno = sessionStorage.getItem("parkingno");
        this.commid = sessionStorage.getItem("id");
        // 获取车位列表
        commonService.getParkingList(this.carNum)

        if (this.$store.state.browserType == "wx") {
            if(!this.commonUtil.getUrlKey("originalId")){//originalId为空说明是还没进行过第二次回调
                let data = sessionStorage.getItem("payList");
                if(data){
                    data = JSON.parse(data)
                    data = data.join(",")//支持支付方式的支付串
                    if(data.indexOf("QR")!=-1 || data.indexOf("WX")!=-1){//微信支付或者聚合支付才进行第二次回调
                        let appid = sessionStorage.getItem("appid");
                        this.commonUtil.wxopenid(appid);
                    }
                }
            }
        }

    },
    mounted(){
        this.boxMaxWidth =  document.getElementById("percentBox").clientWidth;
        this.boxWidth = this.boxMaxWidth*0.5+3.5;
    },
    methods:{
        changePayType(index){//切换支付方式
            this.payActiveIndex = index;
        },
        checkParking(item, index){//勾选车位
            if(!item.checked && this.checkedList.length >= 50){
                this.$dialog.alert({
                    title:"提示",
                    message:"单次最多选取50个车位"
                });
                return;
            }
            const newItem = JSON.parse(JSON.stringify(item))
            newItem.checked = !item.checked
            this.parkingList.splice(index, 1, newItem)
            this.getCheckedStr()
            
        },
        allCheckBtn(){
            this.allChecked = !this.allChecked
            this.parkingList.map((item,index)=>{
                item.checked = index < 50 ? this.allChecked : false
            })
            this.getCheckedStr()
            if(!this.allChecked) return;
            this.parkingList.length > 50 && this.$dialog.alert({
                title:"提示",
                message:"单次最多选取50个车位，已为您选取前50个车位"
            });
            
        },
        getCheckedStr(){//获取选中车位
            let arr = [];
            let arr2 = [];
            this.parkingList.forEach((key,index) => {
                if(key.checked){
                    arr.push("车位"+(index+1));
                    arr2.push({id:key.id})
                }
            });
            this.checkedList = arr2
            this.checkedStr = arr.join("、")
            if(this.checkedStr.length == 0){
                this.totalFee = "0.00";
            }
        },
        getTotalFee(){//查询费用
            
            let req = {
                commid:this.commid,
                vehicleno:this.carNum,
                number:this.month,
                spaces:JSON.stringify(this.checkedList),
                parkingno:this.parkingno,
            }
                      
            this.$http({
                method: 'post',
                url: API.COMMIT_SETMEAL_RENEW,
                data: this.qs.stringify(req),
                success: function(result){
                    if (result.code == '0') {
                        var datas = result.data;
                        var projectDo = result.projectDo;
                        if (datas.appid) { //微信下单appid
                            sessionStorage.setItem("appid", datas.appid);
                        }
                        this.projectDo = result.projectDo;
                        this.totalFee = datas.payfee;
                        this.tradeno = datas.tradeno;
                        // 返回停车场数量不定
                        this.parkingList.forEach(ele=>{
                            datas.spaces.forEach(item=>{
                                if(ele.id == item.id){
                                    ele.start = item.start
                                    ele.stop = item.stop
                                }
                            })
                        })
                        
                        sessionStorage.setItem("tradeno",this.tradeno);
                        sessionStorage.setItem("orderId",result.orderId);
                        sessionStorage.setItem("payfee",this.totalFee);
                        
                        sessionStorage.setItem("payList","");
                        if (!this.commonUtil.isEmpty(projectDo)) {
                            sessionStorage.setItem("payList",JSON.stringify(projectDo));
                            //新增中行支付
                            let str = projectDo.join(",");
                            if(str.indexOf("CCBQR") >= 0 && str.indexOf("BOCQR") >= 0){//建行支付和中国银行支付同时存在
                                if(str.indexOf("CCBQR") > str.indexOf("BOCQR")){//谁在后面就删掉谁
                                    this.delCookie("ccbqrPaystate");//建行
                                }else{
                                    this.delCookie("bocqrPaystate");//中国银行
                                }
                            }
                            if (this.$store.state.browserType == "wx") {
                                if(!this.commonUtil.getUrlKey("originalId")){//originalId为空说明是还没进行过第二次回调
                                    let data = sessionStorage.getItem("payList");
                                    data = JSON.parse(data);
                                    if(data){
                                        data = data.join(",")//支持支付方式的支付串
                                        if(data.indexOf("QR")!=-1 || data.indexOf("WX")!=-1){//微信支付或者聚合支付才进行第二次回调
                                            let appid=sessionStorage.getItem("appid");
                                            this.commonUtil.wxopenid(appid);
                                        }
                                    }
                                }
                            }
                        }
                    }else{
                        this.$dialog.alert({
                            title: '提示',
                            message: result.msg
                        })
                    }
                }.bind(this),
                error: function(error){
                    console.log(error)
                }
            })
        },
        //支付方式显示
        showPayWay(){
            let list = [];
            let myList = [];
            let data = sessionStorage.getItem("payList");
            //alert(data);
            if(data){
                myList=JSON.parse(data)
            }
            //let list = this.$store.state.payList;
            if(this.bsType == "wx"){//微信中删掉支付宝支付
                let myItem = myList.join(",").indexOf("WX");
                myList.forEach((key,index) => {
                    if(this.hidePayList.indexOf(key) !== -1 || key == 'AL'){
                        key="";
                    }
                    if(myItem >= 0){//在微信浏览器且包含微信支付 删除所有聚合支付
                        if(this.hidePayList.map(i=>i+'QR').indexOf(key) !== -1){
                            key="";
                        }
                    }
                    if(key){
                        list.push(key);
                    }
                });
            }else if(this.bsType=="al"){//支付宝中删掉微信支付
                let myItem = myList.join(",").indexOf("AL");
                myList.forEach((key,index) => {
                    if(this.hidePayList.indexOf(key) !== -1 || key == 'WX'){
                        key="";
                    }
                    if(myItem >= 0){//在微信浏览器且包含微信支付 删除所有聚合支付
                        if(this.hidePayList.map(i=>i+'QR').indexOf(key) !== -1){
                            key="";
                        }
                    }
                    if(key){
                        list.push(key);
                    }
                });
            }
            this.payList = list;
        },
        //确认支付
        confirm_pay: function(){
            if(this.disabledClick){
                return;
            }else{
                this.disabledClick = true;
                this.clickTimer = setTimeout(() => {
                    this.disabledClick = false;
                    clearTimeout(this.clickTimer);
                    this.clickTimer = null;
                }, 1000);
            }
            if(this.checkedStr.length == 0){
                this.$dialog.alert({
                    title: '提示',
                    message: '需至少选择一个车位进行充值'
                })
                return;
            }
            sessionStorage.setItem("id",this.commid);
            sessionStorage.setItem("number",this.month);
            sessionStorage.setItem("spaces",JSON.stringify(this.checkedList));
            let payStr = this.payList[this.payActiveIndex];//当前选中的支付方式

            if(!payStr){
                this.$toast("请选择支付方式")
            }
            if(payStr=="UNION"){
                this.$toast("敬请期待")
            }
            if(payStr == "WX"){
                var openid=this.commonUtil.getUrlKey("originalId")
                if(!this.commonUtil.isEmpty(openid)){
                    this.commonUtil.wxPay(this.carNum,"WeChatPay",API.NO_SINGLE_PARKING_PAY);//微信支付 
                }else{
                    this.$toast("请重试")
                }
            }else if(payStr == "AL"){
                this.commonUtil.aliPay(this.carNum,"AliPay",API.NO_SINGLE_PARKING_PAY);//支付宝支付
            }else{
                const filterArr = this.paywayList.filter(i=>i.payway === payStr)
                if(filterArr.length){
                    const paywayItem = filterArr[0]
                    if(paywayItem.isDiff){
                        if(this.bsType == 'wx'){
                            this.commonUtil.wxPay(this.carNum, paywayItem.wxpayChannel,API.NO_SINGLE_PARKING_PAY)
                        }
                        if(this.bsType == 'al'){
                            this.commonUtil.aliPay(this.carNum, paywayItem.alpayChannel,API.NO_SINGLE_PARKING_PAY)
                        }
                    }else{
                        this.commonUtil.bankPay(this.carNum, paywayItem.payway + 'PAY',API.NO_SINGLE_PARKING_PAY)
                    }
                }
            }
        },
        goBack(){
            window.history.go(-2);
        }
    },
    watch:{
        "$store.state.dataObj"(value){
            if(value && value.length>0){
                this.datas = value;
            }
        },
        datas(value){
            if(value && value.length>0){
                let temp = value.filter(i=> i.parkingno == this.parkingno && i.commid == this.commid)
                if(temp.length){
                    this.parkingList = temp[0].spaces.map((item, index)=>{
                        item.checked = index < 50 ? true : false
                        return item
                    })
                    if(this.parkingList.length > 50){
                        this.$dialog.alert({
                            title:"提示",
                            message:"单次最多选取50个车位，已为您选取前50个车位"
                        })
                        this.allChecked = true
                    }else{
                        this.allChecked = false
                    }
                    this.getCheckedStr()
                }
            }
        },
        checkedList(value){//所宣传为发生改变
            if(value.length != 0 && (value.length == this.parkingList.length || value.length >= 50)){
                this.allChecked = true
            }else{
                this.allChecked = false
            }
            if(value && value.length==0){
                return;
            }
            this.getTotalFee()
        },
        month(value){//所选月份发生改变
            if(this.checkedList.length == 0) return
            this.getTotalFee()
        },
        projectDo(value){//支付方式发生改变
            this.showPayWay();
        }
    },

}
</script>
<style lang="css">
@import "../../../static/css/recharge.css";
</style>
<style lang="less" scoped>
    .order-content{
        .parking_container{
            background: #fff;
            position: relative;
            width: 100%;
            box-sizing: border-box;
            padding: 10px 0;
            line-height: 24px;
            font-size: 14px;
            overflow: hidden;
            margin-top: 5px;
            
            h2{
                box-sizing: border-box;
                padding: 0 15px;
                height: 44px;
                line-height: 44px;
                text-align: left;
                position: relative;
                small{
                    font-weight: normal;
                }
                span{
                    font-size: 14px;
                    color: #999;
                }
                .extra{
                    position: absolute;
                    right: 15px;
                    top: 0;
                    height: 44px;
                    line-height: 44px;
                }
            }
            .list-box{
                box-sizing: border-box;
                padding: 0 15px;
                max-height: 20vh;
                width: 100vw;
                overflow-y: auto;
            }
            b.cus_check_box{
                width: 20px;
                height: 20px;
                border: 1px solid #999;
                border-radius: 3px;
                &.check1{
                    float: right;
                    margin-top: 10px;
                }
                &.check2{
                    display: inline-block;
                    margin-top: 12px;
                }
                &.active{
                    background:url("../../../static/images/checked.png") no-repeat 2px 2px;
                    background-size: 16px;
                }
            }
            
            li{
                font-size: 14px;
                color: #999;
                height: 44px;
                line-height: 44px;
                text-align: left;
                display: flex;
                border-bottom: 1px solid #e5e5e5;
                &:last-child, &.nobtm{
                    border-bottom: none;
                }
                span{
                    display: flex;
                    flex: 1;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
        }
    }
</style>




// WEBPACK FOOTER //
// src/components/recharge/recharge.vue